import React from "react";
import { SectionsCard } from "./SectionsCard";
import { SectionsUIProvider } from "./SectionsUIContext";

export function SectionsPage({
  history,
  date
}) {
  const sectionsUIEvents = {
    openStudentAbsenteeismsPage: (date, id) => {
      history.push(`/ogrenci-devamsizliklari/${date}/${id}`);
    },
  };

  return (
    <SectionsUIProvider sectionsUIEvents={sectionsUIEvents}>
      <SectionsCard 
        date={date}
      />
    </SectionsUIProvider>
 );
}